module.exports = __webpack_public_path__ + "img/nav-right-expand-search-mazda.ac24f3f2.png";